import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { UtilsService } from '../shared/utils.service';

@Component({
    selector: 'app-contact-us',
    templateUrl: './contact-us.component.html',
    styleUrls: ['./contact-us.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ContactUsComponent implements OnInit {

  constructor(
    public utils: UtilsService
  ) {}

  ngOnInit() {}
}
